import { Box, Chip, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { useAuth } from '../../../../contexts/AuthContext';
import { useEikenMaterialList } from '../hooks/useEikenMaterialList';

const tabLabels = [
  { label: 'Full Test', title: 'All Eiken Tests', disabled: false },
  { label: 'Pronunciation', title: 'Pronunciation', disabled: true },
  { label: 'Question 1', title: 'Question 1', disabled: true },
  { label: 'Question 2', title: 'Question 2', disabled: true },
  { label: 'Question 3', title: 'Question 3', disabled: true },
  { label: 'Question 4', title: 'Question 4', disabled: true },
];

export function ListPageHeader() {
  const { user } = useAuth();
  const [tab, setTab] = useState(0);
  const { count } = useEikenMaterialList();

  return (
    <Box className="flex flex-col h-full">
      <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
        👋 Hey, {user?.data.firstName}!
      </Typography>
      <Typography variant="h1">{tabLabels[tab].title}</Typography>
      <Box className="flex-grow"></Box>
      <Box>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          {tabLabels.map((t, i) => (
            <Tab
              key={t.label}
              disabled={t.disabled}
              label={
                <Box display="flex" alignItems="center" gap={1}>
                  {t.label}
                  {t.label === 'Full Test' && count > 0 && (
                    <Chip
                      label={count}
                      size="small"
                      color="primary"
                      sx={{ fontSize: 12, height: 20 }}
                    />
                  )}
                </Box>
              }
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
}
